
import { Container, ModalBody } from 'reactstrap'
import React from 'react'
export default class SelectableStates extends React.Component {
  coloradoImageSource = '/assets/colorado.svg';
  kentuckyImageSource = '/assets/kentucky.svg';
  northCarolinaImageSource = '/assets/northcarolina.svg';
  southCarolinaImageSource = '/assets/southcarolina.svg';
  arkansasImageSource = '/assets/arkansas.svg';
  louisanaImageSource = '/assets/louisana.svg';
  mississippiImageSource = '/assets/mississippi.svg';
  georgiaImageSource = '/assets/georgia.svg';
  virginiaImageSource = '/assets/virginia.svg';
  floridaImageSource = '/assets/florida.svg';
  texasImageSource = '/assets/texas.svg';

  constructor (props) {
    super(props)
    const zip = props.formProps && props.formProps.zip ? props.formProps.zip : ''
    this.state = {
      overlayVisibility: 'hidden',
      showModal: false,
      zip
    }
  }

  // initialize modal as invisible on initaliziation of component
  componentDidMount () {
    this.setState({
      ...this.props,
      overlayVisibility: 'hidden',
      showModal: false
    })
  }
  // initialize modal as invisible on destroying of component
  componentWillUnmount () {
    this.setState({
      ...this.props,
      overlayVisibility: 'hidden',
      showModal: false
    })
  }

  handleStateSelection = (event) => {
    if (this.props.handleStateSelection) {
      this.setState({
        ...this.state,
        overlayVisibility: 'visible',
        showModal: true
      })
      document.querySelector('#stateSelector').classList.add('in')
      this.props.handleStateSelection(event)
    }
  }

  onZipCodeChanged = (event) => {
    this.setState({
      zip: event.target.value
    })

    if (this.props.onZipCodeChanged) { this.props.onZipCodeChanged(event) }
  }

  render () {
    return (
      <div>
        <Container fluid id='stateSelector' style={{ padding: '0' }}>
          <div style={{ visibility: this.state.overlayVisibility }} id='overlay' className='filter-greyscale' />

          <img alt='Colorado' onClick={this.handleStateSelection} id='CO' style={{ position: 'relative', left: 50 }} src={this.coloradoImageSource} className='state-img img-fluid' />
          <img alt='Kentucky' onClick={this.handleStateSelection} id='KY' style={{ position: 'relative', left: 226, bottom: 5 }} src={this.kentuckyImageSource} className='state-img img-fluid' />
          <img alt='Virginia' onClick={this.handleStateSelection} id='VA' style={{ position: 'relative', left: 215, bottom: 21 }} src={this.virginiaImageSource} className='state-img img-fluid' />
          <img alt='Texas' onClick={this.handleStateSelection} id='TX' style={{ position: 'relative', 'top': 140, right: 239 }} src={this.texasImageSource} className='state-img img-fluid' />

          <div>
            <div className='help-block'>
              <img alt='Arkansas' onClick={this.handleStateSelection} id='AR' style={{ position: 'relative', 'bottom': 52, 'left': 234 }} src={this.arkansasImageSource} className='state-img img-fluid' />
            </div>
            <img alt='Louisiana' onClick={this.handleStateSelection} id='LA' style={{ position: 'relative', left: 244, bottom: 60 }} src={this.louisanaImageSource} className='state-img img-fluid' />
            <img alt='Mississippi' onClick={this.handleStateSelection} id='MS' style={{ position: 'relative', left: 221, bottom: 95 }} src={this.mississippiImageSource} className='state-img img-fluid' />
            <img alt='North Carolina' onClick={this.handleStateSelection} id='NC' style={{ position: 'relative', left: 280, bottom: 180 }} src={this.northCarolinaImageSource} className='state-img img-fluid' />
            <img alt='South Carolina' onClick={this.handleStateSelection} id='SC' style={{ position: 'relative', left: 178, bottom: 138 }} src={this.southCarolinaImageSource} className='state-img img-fluid' />
            <img alt='Georgia' onClick={this.handleStateSelection} id='GA' style={{ position: 'relative', left: 75, bottom: 107, height: 80 }} src={this.georgiaImageSource} className='state-img img-fluid' />
            <img alt='Florida' onClick={this.handleStateSelection} id='FL' src={this.floridaImageSource} className='state-img img-fluid' style={{ position: 'relative', bottom: 25, left: -15 }} />
          </div>
          <div id={'zipCodeModal'} className='modal__bg  slide2-modal-container' role={'dialog'} aria-hidden={'true'} style={{ visibility: this.state.overlayVisibility }}>
            <div className='modal-dialog'>
              <h2 className='h2-sized-down text-center'>ENTER YOUR ZIP CODE</h2>
              <ModalBody>
                <div className='form-group' id={'zip-code-grid'} >
                  <h2 className='h2-sized-down zip-label text-right' style={{ color: '#222' }}>ZIP CODE</h2>
                  <input type='text' style={{ pointerEvents: 'all' }} onChange={this.onZipCodeChanged} value={this.state.zip} maxLength={5} className='zip-code form-control' id='inputZipCode' />
                </div>
                <span className='text-danger' id='zipCodeError' />
              </ModalBody>
            </div>
          </div>
        </Container>

      </div>
    )
  }
};
